export default __webpack_public_path__ + "static/media/logo-chaveiro.e64db22f.png";